module.exports = __webpack_public_path__ + "static/img/14.9ddbf83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14.jpg
// module id = anPB
// module chunks = 1